import React, { useState } from "react";
import { NavLink } from "react-router-dom";
import { logActivity } from "../utils/activity";
import siteData from "../data/site.json";
import authCopy from "../data/private/auth.json";

const linkMap = {
  Home: "/",
  About: "/about",
  Features: "/features",
  Pricing: "/pricing",
  Blog: "/blog",
  Contact: "/contact",
};

export default function Header() {
  const [open, setOpen] = useState(false);
  const navLabels = (siteData.footer?.quickLinks || []).filter(
    (label) => linkMap[label]
  );

  return (
    <header className="fixed inset-x-0 top-0 z-50 border-b border-slate-200 bg-white/90 backdrop-blur">
      <div className="mx-auto flex w-full max-w-6xl items-center justify-between px-4 py-4 md:px-6">
        <NavLink to="/" className="flex items-center gap-2">
          <div className="flex h-9 w-9 items-center justify-center rounded-full bg-amber-500 text-white">
            {siteData.brand?.short || "MYV"}
          </div>
          <span className="text-lg font-semibold text-slate-900">
            {`${siteData.brand?.name || "Manage Your Vastu"} (${
              siteData.brand?.short || "MYV"
            })`}
          </span>
        </NavLink>

        <nav className="hidden items-center gap-6 text-sm font-medium text-slate-700 md:flex">
          {navLabels.map((label) => (
            <NavLink
              key={label}
              to={linkMap[label]}
              className="transition hover:text-amber-600"
              onClick={() =>
                logActivity("nav_click", { label, to: linkMap[label] })
              }
            >
              {label}
            </NavLink>
          ))}
        </nav>

        <div className="hidden items-center gap-3 md:flex">
          <NavLink
            to="/login"
            className="btn btn-primary"
            onClick={() =>
              logActivity("cta_click", { label: authCopy.signup.footerLinkLabel })
            }
          >
            {authCopy.signup.footerLinkLabel}
          </NavLink>
          <NavLink
            to="/signup"
            className="btn btn-secondary"
            onClick={() =>
              logActivity("cta_click", { label: authCopy.login.footerLinkLabel })
            }
          >
            {authCopy.login.footerLinkLabel}
          </NavLink>
        </div>

        <button
          className="inline-flex items-center rounded-md border border-slate-300 p-2 text-slate-700 transition hover:border-amber-400 md:hidden"
          onClick={() => setOpen((prev) => !prev)}
          aria-label="Toggle menu"
          aria-expanded={open}
        >
          <span className="block h-0.5 w-5 bg-slate-700" />
          <span className="mt-1.5 block h-0.5 w-5 bg-slate-700" />
          <span className="mt-1.5 block h-0.5 w-5 bg-slate-700" />
        </button>
      </div>

      <div
        className={`overflow-hidden border-t border-slate-200 bg-white transition-all duration-300 md:hidden ${
          open ? "max-h-96 opacity-100" : "max-h-0 opacity-0"
        }`}
      >
        <div className="mx-auto flex max-w-6xl flex-col gap-4 px-4 py-6">
          {navLabels.map((label) => (
            <NavLink
              key={label}
              to={linkMap[label]}
              className="text-sm text-slate-700 transition hover:text-amber-600"
              onClick={() => {
                logActivity("nav_click", { label, to: linkMap[label] });
                setOpen(false);
              }}
            >
              {label}
            </NavLink>
          ))}
          <NavLink
            to="/login"
            className="btn btn-primary"
            onClick={() =>
              logActivity("cta_click", { label: authCopy.signup.footerLinkLabel })
            }
          >
            {authCopy.signup.footerLinkLabel}
          </NavLink>
          <NavLink
            to="/signup"
            className="btn btn-secondary"
            onClick={() =>
              logActivity("cta_click", { label: authCopy.login.footerLinkLabel })
            }
          >
            {authCopy.login.footerLinkLabel}
          </NavLink>
        </div>
      </div>
    </header>
  );
}
